<template>
    <div>
        <Separator :label="$t('page.videos')"></Separator>
        <div class="container-fluid__with-padding" v-if="videos.length === 1">
            <div class="row justify-content-center">
                <div class="col-12 text-center">
                    <video-slide
                        :video="videos[0]"
                    />
                </div>
            </div>
        </div>
        <div class="container-fluid__with-padding" v-else-if="videos.length > 1">
            <VueSlickCarousel v-bind="settingsSlider">
                <video-slide
                    v-for="video in videos"
                    :key="video.id"
                    :video="video"
                />

                <template #prevArrow="arrowOption">
                    <div class="custom-arrow-left">
                        <div class="slick-button">
                            <chevron-left-icon :size="32"></chevron-left-icon>
                        </div>
                    </div>
                </template>
                <template #nextArrow="arrowOption">
                    <div class="custom-arrow-right">
                        <div class="slick-button">
                            <chevron-right-icon :size="32"></chevron-right-icon>
                        </div>
                    </div>
                </template>
            </VueSlickCarousel>
        </div>
    </div>

</template>

<script>
    import Separator from './Separator'
    import VueSlickCarousel from 'vue-slick-carousel'
    import VideoSlide from "./VideoSlide";
    import ChevronLeftIcon from 'vue-material-design-icons/ChevronLeft';
    import ChevronRightIcon from 'vue-material-design-icons/ChevronRight';

    export default {
        name: "VideoSlider",
        components: {
            Separator,
            VueSlickCarousel,
            VideoSlide,
            ChevronLeftIcon,
            ChevronRightIcon
        },
        props: {
            videos: {
                type: Array
            }
        },
        /*watch: {
            events: function () {
                /!**
                 * Patch found here https://github.com/gs-shop/vue-slick-carousel/issues/84
                 *
                 * When using a dynamic array, it's the only way to tell the component that it need to refresh
                 *
                 *!/
                this.settingsSlider.slidesToShow = 2;
                this.$nextTick(() => {
                    this.settingsSlider.slidesToShow = 1;
                })
            }
        },*/
        data: () => {
            return {
                lastPadding: 0,
                settingsSlider: {
                    dots: true,
                    infinite: false,
                    centerMode: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    speed: 500,
                    initialSlide: 0,
                    centerPadding: "0px",
                    autoplay: false,
                    autoplaySpeed: 5000,
                    pauseOnFocus: true,
                    swipeToSlide: true,
                    variableWidth: false,
                    draggable: true,
                    adaptiveHeight: false,
                    responsive: [
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                variableWidth: false,
                                centerMode: true,
                                adaptiveHeight: false
                            }
                        }
                    ]

                }
            }
        }
    }
</script>

